import { Controller } from "@hotwired/stimulus"

// A panel with a toggle button, remembered across Turbo Frame re-renders.
// The library's filter form re-renders on every change, which would close
// the sheet the somm is working in; the open state is kept in sessionStorage
// under `key` so the new render comes back the way it was left.
//
// Above the `media` query (the desktop sidebar) the panel is always shown
// and the toggle has nothing to do.
export default class extends Controller {
  static targets = ["panel", "button"]
  static values = { key: String, open: Boolean, media: String }

  connect() {
    const stored = this.read()
    if (stored !== null) this.openValue = stored
    if (this.hasMediaValue) {
      this.mediaQuery = matchMedia(this.mediaValue)
      this.onMediaChange = () => this.render()
      this.mediaQuery.addEventListener("change", this.onMediaChange)
    }
    this.render()
  }

  disconnect() {
    this.mediaQuery?.removeEventListener("change", this.onMediaChange)
  }

  toggle() {
    this.openValue = !this.openValue
    this.store()
    this.render()
  }

  close() {
    this.openValue = false
    this.store()
    this.render()
  }

  render() {
    const shown = this.alwaysShown || this.openValue
    this.panelTarget.hidden = !shown
    this.buttonTargets.forEach((button) => button.setAttribute("aria-expanded", String(shown)))
  }

  get alwaysShown() {
    return Boolean(this.mediaQuery?.matches)
  }

  read() {
    try {
      const value = sessionStorage.getItem(this.storageKey)
      return value === null ? null : value === "1"
    } catch (e) {
      return null
    }
  }

  store() {
    try { sessionStorage.setItem(this.storageKey, this.openValue ? "1" : "0") } catch (e) { /* best effort */ }
  }

  get storageKey() {
    return `winote_disclosure:${this.keyValue}`
  }
}
